import React, {useState} from 'react';
import { Modal } from 'antd';
import Questionnaire from './Questionnarie'

const ModalQuestionnaire = ({ title, questions, totalshowQuestion, open, close, onSave, idx }) => {
    const onComplete = (questions) => {
        onSave(questions);
        close();
    };

    const onCancel = () => {
        close();
    }
    const isClear = () => {
        return open;
    };
    
    return (
        <Modal title={title} open={open} onCancel={onCancel} width={1000} footer={null}>
            <Questionnaire questions={questions} totalshowQuestion={totalshowQuestion} onSave={onComplete} clear={isClear} key={idx}   />
        </Modal>
    );
};
export default ModalQuestionnaire;